import { z } from 'zod';

export const finalOrderSearchSchema = z.object({
  travelId: z.string().uuid(),
});
